import { formatDistanceToNowStrict } from 'date-fns'

import { Badge, Flex, Text } from '@buffer-mono/popcorn'

import { useCommentData } from '../../context/CommentContext'

export const CommentHeader = (): JSX.Element => {
  const comment = useCommentData()

  return (
    <Flex id={`comment-header-${comment.id}`} align="center" gap="xs">
      {comment.isOwnReply ? (
        <Badge color="subtle" size="medium">
          {comment.author.username}
        </Badge>
      ) : (
        <Text weight="bold">{comment.author.username}</Text>
      )}
      {comment.publishedAt && (
        <Text size="sm" color="subtle">
          {formatDistanceToNowStrict(new Date(comment.publishedAt))} ago
        </Text>
      )}
    </Flex>
  )
}
